/** Текст ошибки API, когда сессия бронирования закрыта, но счета уже созданы */
export const RESERVATION_CLOSED_INVOICES_ERROR =
  "Бронирование закрыто, счета созданы";

function apiErrorMessage(err) {
  const raw = err?.data;
  if (typeof raw === "string") return raw;
  if (raw && typeof raw === "object") {
    return raw.error ?? raw.detail;
  }
  return undefined;
}

export function isReservationClosedInvoicesError(err) {
  const msg = apiErrorMessage(err);
  return typeof msg === "string" && msg === RESERVATION_CLOSED_INVOICES_ERROR;
}

export function redirectReservationClosedInvoicesHistory(
  reservationUuid,
  navigate
) {
  if (!reservationUuid) return;
  const path = `/reservation/${reservationUuid}`;
  if (typeof navigate === "function") {
    navigate(path, { replace: true });
  } else {
    window.location.replace(path);
  }
}

/** @returns {boolean} true если выполнен переход (ошибка совпала и uuid есть) */
export function tryRedirectReservationClosedInvoices(
  navigate,
  reservationUuid,
  err
) {
  if (!reservationUuid || !isReservationClosedInvoicesError(err)) {
    return false;
  }
  redirectReservationClosedInvoicesHistory(reservationUuid, navigate);
  return true;
}
